import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared';

/**
 * Lease observe candidates request.
 */
export class LeaseMeteringObserveRequest {
  leasedBy!: string;
  @TransformDate()
  leasedUntil!: Date;
  @TransformInt()
  batch!: number;
}
